import { render, staticRenderFns } from "./ProfileApprovalPage.vue?vue&type=template&id=21346818"
import script from "./ProfileApprovalPage.vue?vue&type=script&lang=js"
export * from "./ProfileApprovalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports